// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610012236/js/" + chunkId + "." + {"44":"bd18aa82","225":"ee381d01","481":"b4d3f48c","486":"b6dab93a","770":"8b88a1b0"}[chunkId] + ".0.7091667179073566.chunk.js";
};